export const DEFAULT_CPI_TABLE: Record<string, number> = {
  US: 0.25,
  CA: 0.22,
  MX: 0.15,
  BR: 0.15,
  AR: 0.13,
  CL: 0.14,
  CO: 0.13,
  GB: 0.2,
  IE: 0.19,
  FR: 0.18,
  DE: 0.2,
  ES: 0.18,
  IT: 0.17,
  PT: 0.16,
  NL: 0.19,
  BE: 0.18,
  SE: 0.21,
  NO: 0.22,
  FI: 0.2,
  DK: 0.21,
  AU: 0.21,
  NZ: 0.2,
  JP: 0.24,
  KR: 0.22,
  SG: 0.19,
  HK: 0.18,
  TW: 0.17,
  PH: 0.13,
  TH: 0.14,
  VN: 0.12,
  MY: 0.13,
  ID: 0.11,
  IN: 0.1,
  PK: 0.09,
  BD: 0.08,
  AE: 0.2,
  SA: 0.18,
  QA: 0.19,
  KW: 0.2,
  ZA: 0.14,
  NG: 0.11,
  KE: 0.1,
};

export function getCpiForCountry(
  countryCode: string,
  overrides?: Record<string, number>
): number {
  const normalized = countryCode.toUpperCase();
  if (overrides?.[normalized] !== undefined) {
    return overrides[normalized];
  }
  return DEFAULT_CPI_TABLE[normalized] ?? 0.08;
}

/**
 * Calculate the final CPI for an install event.
 * Android users get $0.03 cheaper than iOS.
 * @param countryCode ISO country code (e.g., 'US')
 * @param platform 'and' (Android) or 'ios' (iOS)
 * @returns Final CPI rate for this install
 */
export function calculateCpi(countryCode: string, platform: string): number {
  const baseCpi = getCpiForCountry(countryCode);
  const isAndroid = platform.toLowerCase() === 'and' || platform.toLowerCase() === 'android';
  return isAndroid ? Math.max(0, baseCpi - 0.03) : baseCpi;
}

/**
 * Normalize a ref tag by removing all special characters (keep only alphanumeric).
 * Used to match user handles with GA4 event refs.
 * @param ref The raw ref string
 * @returns Normalized lowercase alphanumeric string
 */
export function normalizeRef(ref: string): string {
  return ref.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}
